var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactlist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1301_119093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5455 5.44444H11.1767L10.8509 4.79806C10.6044 4.30911 10.1011 4 9.55055 4H3.45455C2.65091 4 2 4.64639 2 5.44444V15.5556C2 16.3536 2.65091 17 3.45455 17H4.18182C4.58327 17 4.90909 16.6764 4.90909 16.2778V15.5556C4.90909 15.1569 5.23491 14.8333 5.63636 14.8333C6.03782 14.8333 6.36364 15.1569 6.36364 15.5556V16.2778C6.36364 16.6764 6.68945 17 7.09091 17H12.9091C13.3105 17 13.6364 16.6764 13.6364 16.2778V15.5556C13.6364 15.1569 13.9622 14.8333 14.3636 14.8333C14.7651 14.8333 15.0909 15.1569 15.0909 15.5556V16.2778C15.0909 16.6764 15.4167 17 15.8182 17H16.5455C17.3491 17 18 16.3536 18 15.5556V6.88889C18 6.09083 17.3491 5.44444 16.5455 5.44444ZM7.09091 8.33333H12.9091C13.2029 8.33333 13.4531 8.50811 13.568 8.75728L10 10.9629L6.43927 8.74717C6.55636 8.50378 6.80145 8.33333 7.09091 8.33333ZM13.6364 12.6667C13.6364 13.0653 13.3105 13.3889 12.9091 13.3889H7.09091C6.68945 13.3889 6.36364 13.0653 6.36364 12.6667V10.3252L9.22982 12.1091C9.70109 12.4023 10.2989 12.4031 10.7709 12.1113L13.6364 10.3404V12.6667Z",
    fill: "black",
    fillOpacity: 0.54
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1301_119093"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactlist);
export default __webpack_public_path__ + "static/media/contact list.74afef8e778ac036d76bee66ea534373.svg";
export { ForwardRef as ReactComponent };